(function () {
  "use strict";

  window.TND = window.TND || {};

  var LS_KEY = "tnd_spirits_launched";
  var COOKIE = "tnd_spirits_launched";
  var META_KEY = "tnd_spirits_launch_meta";
  var MAX_GIDS = 50;
  var MAX_META = 10;
  var CHANNEL = "tnd_cart_updates";
  var _prewarmedUrl = null;
  var _prewarmedGid = null;

  function normalizeEntries(value) {
    var source = Array.isArray(value) ? value : [];
    var output = [];
    var seen = {};

    source.forEach(function (entry) {
      var gid = typeof entry === "string" ? entry : entry && entry.gid;
      if (!gid || seen[gid]) return;
      seen[gid] = true;
      output.push(gid);
    });

    return output;
  }

  function decodeArray(raw, allowRawJson) {
    var parsed;

    if (!raw) return [];

    try {
      parsed = JSON.parse(raw);
      if (allowRawJson) return normalizeEntries(parsed);
    } catch (error) {
      // localStorage may contain base64(JSON); cookie always does.
    }

    try {
      parsed = JSON.parse(atob(raw));
      return normalizeEntries(parsed);
    } catch (error) {
      return [];
    }
  }

  function encodeArray(array) {
    return btoa(JSON.stringify(array));
  }

  function readCookieValue() {
    var parts = document.cookie ? document.cookie.split(";") : [];
    var prefix = COOKIE + "=";
    var i;
    var part;

    for (i = 0; i < parts.length; i += 1) {
      part = parts[i].trim();
      if (part.indexOf(prefix) === 0) {
        return decodeURIComponent(part.slice(prefix.length));
      }
    }

    return "";
  }

  function _readLayer_ls() {
    try {
      return decodeArray(localStorage.getItem(LS_KEY), true);
    } catch (error) {
      return [];
    }
  }

  function _readLayer_cookie() {
    try {
      return decodeArray(readCookieValue(), false);
    } catch (error) {
      return [];
    }
  }

  function unionLayers() {
    var output = [];
    var seen = {};

    _readLayer_ls().concat(_readLayer_cookie()).forEach(function (gid) {
      if (!gid || seen[gid]) return;
      seen[gid] = true;
      output.push(gid);
    });

    return output;
  }

  function capFifo(array) {
    return array.slice(Math.max(0, array.length - MAX_GIDS));
  }

  function launchedGids() {
    // CR-7: union, not intersection; any durable layer marking a GID launched wins.
    return unionLayers();
  }

  function statusFor(gid) {
    // R1/H-4: LAUNCHED is terminal per spirits cart GID; no expiry state exists.
    return gid && launchedGids().indexOf(gid) !== -1 ? "LAUNCHED" : null;
  }

  function writeLs(array, gid) {
    localStorage.setItem(LS_KEY, encodeArray(array));
    return _readLayer_ls().indexOf(gid) !== -1;
  }

  function writeCookie(array, gid) {
    document.cookie =
      COOKIE +
      "=" +
      encodeURIComponent(encodeArray(array)) +
      "; path=/; Max-Age=34560000; SameSite=Lax; Secure";
    return _readLayer_cookie().indexOf(gid) !== -1;
  }

  // Launch metadata (checkoutUrl + timestamp per GID), localStorage-only --
  // too big for the cookie layer. Powers the terminal panel's safe "resume
  // your spirits checkout" link: reopening the same checkoutUrl resumes the
  // same cart, and a cart converts to an order exactly once (H-12).
  function readMeta() {
    var parsed;

    try {
      parsed = JSON.parse(localStorage.getItem(META_KEY));
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function recordMeta(gid, url) {
    var meta;
    var gids;

    if (!gid || !url) return;

    try {
      meta = readMeta();
      meta[gid] = { url: url, ts: Date.now() };
      gids = Object.keys(meta);
      if (gids.length > MAX_META) {
        gids.sort(function (a, b) {
          return ((meta[a] && meta[a].ts) || 0) - ((meta[b] && meta[b].ts) || 0);
        });
        while (gids.length > MAX_META) {
          delete meta[gids.shift()];
        }
      }
      localStorage.setItem(META_KEY, JSON.stringify(meta));
    } catch (error) {
      // Metadata is a resume convenience, never a launch-safety layer.
    }
  }

  function getLaunchMeta(gid) {
    var meta = readMeta();
    return gid && meta[gid] && meta[gid].url ? { url: meta[gid].url, ts: meta[gid].ts || 0 } : null;
  }

  function latestLaunch() {
    var meta = readMeta();
    var best = null;

    Object.keys(meta).forEach(function (gid) {
      var entry = meta[gid];
      if (entry && entry.url && (!best || (entry.ts || 0) > best.ts)) {
        best = { gid: gid, url: entry.url, ts: entry.ts || 0 };
      }
    });

    return best;
  }

  function broadcastLaunch(gid) {
    var channel;

    try {
      if (typeof BroadcastChannel !== "function") return;
      channel = new BroadcastChannel(CHANNEL);
      channel.postMessage({ type: "spirits-launched", gid: gid });
      channel.close();
    } catch (error) {
      // BroadcastChannel is convergence only, not a durable launch layer.
    }
  }

  function markLaunched(gid, url) {
    var launched;
    var wroteLs = false;
    var wroteCookie = false;

    if (!gid) return false;

    launched = launchedGids().filter(function (existing) {
      return existing !== gid;
    });
    launched.push(gid);
    launched = capFifo(launched);

    try {
      wroteLs = writeLs(launched, gid);
    } catch (error) {
      wroteLs = false;
    }

    try {
      wroteCookie = writeCookie(launched, gid);
    } catch (error) {
      wroteCookie = false;
    }

    recordMeta(gid, url);
    broadcastLaunch(gid);
    return wroteLs || wroteCookie;
  }

  function prewarm(url, gid) {
    _prewarmedUrl = url || null;
    _prewarmedGid = gid || null;
  }

  function getPrewarm() {
    if (!_prewarmedUrl || !_prewarmedGid) return null;
    return {
      url: _prewarmedUrl,
      gid: _prewarmedGid
    };
  }

  function onLaunch(cb) {
    var channel;

    try {
      if (typeof BroadcastChannel !== "function" || typeof cb !== "function") {
        return function () {};
      }

      channel = new BroadcastChannel(CHANNEL);
      channel.onmessage = function (event) {
        var data = event && event.data;
        if (data && data.type === "spirits-launched") {
          cb(data.gid);
        }
      };

      return function () {
        try {
          channel.close();
        } catch (error) {
          // no-op
        }
      };
    } catch (error) {
      return function () {};
    }
  }

  window.TND.launch = {
    _readLayer_ls: _readLayer_ls,
    _readLayer_cookie: _readLayer_cookie,
    launchedGids: launchedGids,
    statusFor: statusFor,
    markLaunched: markLaunched,
    getLaunchMeta: getLaunchMeta,
    latestLaunch: latestLaunch,
    prewarm: prewarm,
    getPrewarm: getPrewarm,
    onLaunch: onLaunch
  };
})();
